import React from 'react';
import BatteryStdIcon from '@mui/icons-material/BatteryStd';
import Battery6BarIcon from '@mui/icons-material/Battery6Bar';
import Battery5BarIcon from '@mui/icons-material/Battery5Bar';
import Battery4BarIcon from '@mui/icons-material/Battery4Bar';
import Battery3BarIcon from '@mui/icons-material/Battery3Bar';
import Battery2BarIcon from '@mui/icons-material/Battery2Bar';
import Battery1BarIcon from '@mui/icons-material/Battery1Bar';
import Battery0BarIcon from '@mui/icons-material/Battery0Bar';
import SmartLockApiCallerInstance from './SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export function iotMsgBuilder(event, topic, msg, locationPath) {
  const payload = {
    event,
    topic,
    msg,
    locationPath
  };
  return JSON.stringify(payload);
}

/* eslint-disable */

export function Utf8ArrayToStr(array) {
  var out, i, len, c;
  var char2, char3;

  out = '';
  len = array?.length;
  i = 0;
  while (i < len) {
    c = array[i++];
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(
          ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
        );
        break;
    }
  }

  return out;
}
/* eslint-enable */

// get Location

export const getLocationFromLatLng = async (latitude, longitude) => {
  try {
    const response = await SmartLockApiCallerInstance.get(
      `${SMART_LOCK_API_ENDPOINTS.GET_LOCATION_BY_LAT_LNG}?lat=${latitude}&lng=${longitude}`
    );
    return response?.data?.data;
  } catch (error) {
    console.error('Error fetching location:', error);
    return null; // Return null or a fallback value in case of an error
  }
};

export async function getCityFromLatLng(latitude, longitude) {
  try {
    const apiKey = process.env.REACT_APP_G_MAP_API_KEY;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

    const response = await fetch(url);
    if (!response?.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response?.json();
    if (data?.status === 'OK' && data?.results && data?.results.length > 0) {
      const addressComponents = data?.results[0]?.address_components;
      const cityComponent = addressComponents?.find((component) =>
        component.types.includes('locality')
      );
      return cityComponent ? cityComponent?.long_name : null;
    }
    throw new Error('No results found');
  } catch (error) {
    throw new Error(error.message || 'Error fetching location');
  }
}

export const getColorAccordingBattery = (battery) => {
  if (battery !== null && battery !== undefined) {
    if (battery >= 80) return '#0DA626';
    if (battery > 30 && battery < 80) return '#FF9900';
    if (battery <= 30) return '#C30A0A';
  }
  return '#ddd';
};

export const getBatteryIcon = (battery, color) => {
  if (battery !== null && battery !== undefined) {
    switch (true) {
      case battery === 100:
        return <BatteryStdIcon sx={{ color, width: '20px', height: '20px' }} />;
      case battery >= 80:
        return <Battery6BarIcon sx={{ color, width: '20px', height: '20px' }} />;
      case battery >= 60:
        return <Battery5BarIcon sx={{ color, width: '20px', height: '20px' }} />;
      case battery >= 40:
        return <Battery4BarIcon sx={{ color, width: '20px', height: '20px' }} />;
      case battery >= 30:
        return <Battery3BarIcon sx={{ color, width: '20px', height: '20px' }} />;
      case battery >= 20:
        return <Battery2BarIcon sx={{ color, width: '20px', height: '20px' }} />;
      case battery >= 10:
        return <Battery1BarIcon sx={{ color, width: '20px', height: '20px' }} />;
      default:
        return <Battery0BarIcon sx={{ color, width: '20px', height: '20px' }} />;
    }
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'online':
      return '#0DA626';
    case 'offline':
      return '#C30A0A';
    default:
      return '#ffffff';
  }
};

export const getColorAccordingSevertity = (severity) => {
  if (severity !== null && severity !== undefined) {
    switch (severity) {
      case 'HIGH':
        return 'error';
      case 'LOW':
        return 'secondary';
      case 'MEDIUM':
        return 'warning';
      default:
        return 'primary';
    }
  }
  return 'primary';
};

export const truncateText = (text, limit) => {
  if (text?.length > limit) {
    return `${text.substring(0, limit)}...`;
  }
  return text;
};
